import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OAuthData } from '../../../auth/models/oauthdata.model';
import { BusinessTransactionWorkQueueDetailModel } from '../../../shared/models/business-transaction/business-transaction-work-queue-detail-model';
import { WorkQueueModel } from '../../../shared/models/business-transaction/work-queue.model';
import { WIPStatusType } from '../../../wip/models/enums/w-i-p-status-type.enum';
import { AssignmentDropdown } from '../transaction-queue.component';

@Component({
    selector: 'bu-queue',
    templateUrl: './bu-queue.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BuQueueComponent implements OnInit {
    @Input() masterDropdownList: any[];
    @Input() queue: WorkQueueModel;
    @Input() user: OAuthData;
    @Output() onAssignDropDown = new EventEmitter<AssignmentDropdown>();
    @Output() onHold = new EventEmitter<BusinessTransactionWorkQueueDetailModel>();
    @Output() onRedirect = new EventEmitter<BusinessTransactionWorkQueueDetailModel>();
    @Output() onRemove = new EventEmitter<BusinessTransactionWorkQueueDetailModel>();
    @Output() onUnassign = new EventEmitter<BusinessTransactionWorkQueueDetailModel>();

    public dropdownList: any[] = [];
    public multiSortMeta = [];
    public openedIndex: any;
    public wipStatuses: WIPStatusType = new WIPStatusType();

    constructor() { }

    ngOnInit() {
        this.multiSortMeta.push({ field: 'appointmentDate', order: 1 });
        this.multiSortMeta.push({ field: 'updatedDate', order: -1 });
    }

    public assignDropDown(dropdownSelection: AssignmentDropdown) {
        this.onAssignDropDown.emit(dropdownSelection);
    }

    public canRemove(businessTransaction: BusinessTransactionWorkQueueDetailModel) {
        return this.isAssignedToCurrentUser(businessTransaction) || !this.isAssigned(businessTransaction);
    }

    public canUnassign(businessTransaction: BusinessTransactionWorkQueueDetailModel) {
        return this.isAssigned(businessTransaction);
    }

    public holdTransaction(transactionId: number) {
        this.onHold.emit(this.findBusinessTransaction(transactionId));
    }

    public redirectToMyTransaction(businessTransaction: BusinessTransactionWorkQueueDetailModel) {
        this.onRedirect.emit(businessTransaction);
    }

    public removeTransaction(transactionId: number) {
        this.onRemove.emit(this.findBusinessTransaction(transactionId));
    }

    public unassignTransaction(transactionId: number) {
        this.onUnassign.emit(this.findBusinessTransaction(transactionId));
    }

    private findBusinessTransaction(transactionId: number): BusinessTransactionWorkQueueDetailModel {
        return this.queue.businessTransactionDetails.find(transaction => +transaction.transactionId === transactionId);
    }

    private isAssigned(businessTransaction: BusinessTransactionWorkQueueDetailModel) {
        return !!businessTransaction.assignedUserLoginId;
    }

    private isAssignedToCurrentUser(businessTransaction: BusinessTransactionWorkQueueDetailModel) {
        return businessTransaction.assignedTo === this.user.userName;
    }
}
